import { Badge } from "./ui/badge";

interface PostHeroProps {
  title: string;
  category: string;
  coverImageUrl?: string;
}

export function PostHero({ title, category, coverImageUrl }: PostHeroProps) {
  const defaultGradient = "linear-gradient(135deg, hsl(240, 14%, 35%) 0%, hsl(214, 29%, 89%) 100%)";
  
  return (
    <div 
      className="relative w-full h-[250px] sm:h-[350px] md:h-[400px] flex items-center justify-center overflow-hidden mb-8 -mx-4"
      style={{
        background: defaultGradient
      }}
    >
      {coverImageUrl && (
        <img 
          src={coverImageUrl} 
          alt={title}
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-black/30"></div>
      
      <div className="relative z-10 container mx-auto px-4 text-center">
        <Badge className="mb-4 bg-kopf-accent text-kopf-text hover:bg-kopf-accent/80 text-xs sm:text-sm">
          {category}
        </Badge>
        <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white leading-tight max-w-4xl mx-auto px-4">
          {title}
        </h1>
      </div>
    </div>
  );
}